import { ReactNode, createContext } from "react";
import useEmpresa, { EmpresaType, CreateEmpresaType, EditEmpresaType } from "./hooks/useEmpresa";

interface EmpresaContextProviderProps {
    children: ReactNode;
}

export interface EmpresaContextData {
    createEmpresa: (createEmpresaType: CreateEmpresaType) => Promise<CreateEmpresaType | null>;
    getEmpresaPaged: (pageNumber: number, Name?: string, pageSize?: number) => Promise<EmpresaType[] | null>;
    updateEmpresa: (updateEmpresaData: EditEmpresaType) => Promise<EditEmpresaType | null>;
    deleteEmpresa: (EmpresaId: number) => Promise<EmpresaType | null>;
    handleGetEmpresaByUserId: (userId: number) => Promise<EmpresaType | null>;
    handleGetEmpresaById: (empresaId: number) => Promise<EmpresaType | null>;
    empresa: EmpresaType;
    setEmpresa: any;
    listEmpresa: EmpresaType[];
    pageCount: number;
    initialListEmpresa: EmpresaType[];
}

const initialState: EmpresaContextData = {
    createEmpresa: async () => Promise.resolve(null),
    getEmpresaPaged: async () => Promise.resolve(null),
    updateEmpresa: async () => Promise.resolve(null),
    deleteEmpresa: async () => Promise.resolve(null),
    handleGetEmpresaByUserId: async () => Promise.resolve(null),
    handleGetEmpresaById: async () => Promise.resolve(null),
    empresa: {
        id: 0,
        name: "",
        email: "",
        agencia: "",
        contaBeneficiario: "",
        User: {
            Id: 0,
        },
    },
    setEmpresa: () => {},
    listEmpresa: [],
    pageCount: 0,
    initialListEmpresa: [],
};

export const EmpresaContext =
    createContext<EmpresaContextData>(initialState);

export default function EmpresaContextProvider({
    children,
}: EmpresaContextProviderProps) {
    const {
        createEmpresa,
        getEmpresaPaged,
        updateEmpresa,
        deleteEmpresa,
        handleGetEmpresaByUserId,
        handleGetEmpresaById,
        empresa,
        setEmpresa,
        listEmpresa,
        pageCount,
        initialListEmpresa,
    } = useEmpresa();

    return (
        <EmpresaContext.Provider
            value={{
                createEmpresa,
                getEmpresaPaged,
                updateEmpresa,
                deleteEmpresa,
                handleGetEmpresaByUserId,
                handleGetEmpresaById,
                empresa,
                setEmpresa,
                listEmpresa,
                pageCount,
                initialListEmpresa,
            }}
        >
            {children}
        </EmpresaContext.Provider>
    );
}
